import { el } from 'redom';

import CodeEditorInputBox from './';

class CodeEditorInputBoxRow {

  constructor(configuration) {

    this.input = new CodeEditorInputBox(configuration);

    this.el = el('.code-editor-input-row', {
      class: 'form-input-row'
    }, [
      el('label', configuration.label),
      this.input
    ]);

  }

}

export default CodeEditorInputBoxRow;